import { APIService } from "./APIService"
import {
  AdCampaignStatus,
  AdCampaignType,
  AddAdCampaign,
  AdGeoTarget,
  AdSystem,
  AdSystemSettings,
  Page,
} from "./types"

const getOfferCampaigns = (offerId: string) =>
  APIService.get<null, AdCampaignType[]>(`/admin/offers/${offerId}/campaigns`)

const getCampaigns = (status: AdCampaignStatus | null, page: number, size?: number) =>
  APIService.get<null, Page<AdCampaignType>>(
    `/admin/campaigns?${status ? `status=${status}&` : ""}page=${page}&size=${size ?? 20}`,
  )

const getCampaign = (campaignId: string) =>
  APIService.get<null, AdCampaignType>(`/admin/campaigns/${campaignId}`)

const createCampaign = (offerId: string, body: AddAdCampaign) =>
  APIService.post<AddAdCampaign, AdCampaignType>(`/admin/offers/${offerId}/campaigns`, body)

const retryCampaign = (campaignId: string) =>
  APIService.post<null, AdCampaignType>(`/admin/campaigns/${campaignId}/retry`)

const updateBudget = (campaignId: string, dailyBudget?: number, spendLimit?: number) =>
  APIService.patch<{ dailyBudget?: number; spendLimit?: number }, AdCampaignType>(
    `/admin/campaigns/${campaignId}/budget`,
    { dailyBudget, spendLimit },
  )

const renewCampaign = (campaignId: string, additionalSpendLimit: number, dailyBudget?: number) =>
  APIService.patch<{ additionalSpendLimit: number; dailyBudget?: number }, AdCampaignType>(
    `/admin/campaigns/${campaignId}/renew`,
    { additionalSpendLimit, dailyBudget },
  )

const deactivateCampaign = (campaignId: string) =>
  APIService.patch<null, AdCampaignType>(`/admin/campaigns/${campaignId}/deactivate`)

const deleteCampaign = (campaignId: string) =>
  APIService.delete<null, null>(`/admin/campaigns/${campaignId}`)

const getSystems = () => APIService.get<null, AdSystemSettings[]>(`/admin/ads/systems`)

const searchGeoTargets = (system: AdSystem, q: string, countryCode?: string, geoType?: string) =>
  APIService.get<null, AdGeoTarget[]>(
    `/admin/ads/targeting/geo?system=${system}&q=${encodeURIComponent(q)}${
      countryCode ? `&countryCode=${countryCode}` : ""
    }${geoType ? `&geoType=${geoType}` : ""}`,
  )

export const AdCampaignsService = {
  getOfferCampaigns,
  getCampaigns,
  getCampaign,
  createCampaign,
  retryCampaign,
  updateBudget,
  renewCampaign,
  deactivateCampaign,
  deleteCampaign,
  getSystems,
  searchGeoTargets,
}
